module.exports = __webpack_public_path__ + "src/assets/img/warranty_card.1d84da23.jpg";